/*
 * @message:
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-11-08 10:41:14
 * @FilePath: \mrc-ess-fronted\src\router\pages.js
 * @最后编辑: Betway
 * @最后修改时间: 2022-04-29 15:31:57
 */
export default {
  //   System
  Page404: () => import("@/Layout/404Page"),
  NetError: () => import("@/Layout/NetErrorPage"),
  SystemErrorPage: () => import("@/Layout/SystemErrorPage"),
  //   看板
  Dashboard: () => import("@/Page/Ess/Dashboard/Dashboard"),
  //   日历
  Calendar: () => import("@/Page/Ess/Calendar2/Calendar"),
  //   审批记录
  Status: () => import("@/Page/Ess/Status/Status"),
  // 硬性年假
  BlockLeaveRecord: () =>
    import("@/Page/Ess/BlockLeave/BlockLeaveRecord/BlockLeaveRecord"),
  SubordinateBlockLeaveRecord: () =>
    import(
      "@/Page/Ess/BlockLeave/SubordinateBlockLeaveRecord/SubordinateBlockLeaveRecord"
    ),
  // 请假
  LeaveApplication: () =>
    import("@/Page/Ess/Leave/LeaveApplication/LeaveApplication"),
  viewLeaveApplication: () =>
    import("@/Page/Ess/Leave/LeaveApplication/viewLeaveApplication"),
  newLeaveApplication: () =>
    import("@/Page/Ess/Leave/LeaveApplication/newLeaveApplication"),
  //   代理请假
  LeaveApplicationOnBehalf: () =>
    import(
      "@/Page/Ess/Leave/LeaveApplicationOnBehalf/LeaveApplicationOnBehalf"
    ),
  NewLeaveApplicationOnBehalf: () =>
    import(
      "@/Page/Ess/Leave/LeaveApplicationOnBehalf/newLeaveApplicationOnBehalf"
    ),
  ViewLeaveApplicationOnBehalf: () =>
    import(
      "@/Page/Ess/Leave/LeaveApplicationOnBehalf/viewLeaveApplicationOnBehalf"
    ),
  // 下属请假
  SubordinateLeaveApplication: () =>
    import(
      "@/Page/Ess/Leave/SubordinateLeaveApplication/SubordinateLeaveApplication"
    ),
  ViewSubordinateLeaveApplication: () =>
    import(
      "@/Page/Ess/Leave/SubordinateLeaveApplication/viewSubordinateLeaveApplication"
    ),
  //  休假结余
  LeaveBalance: () => import("@/Page/Ess/Leave/LeaveBalance/LeaveBalance"),
  // 下属休假结余
  SubordinateLeaveBalance: () =>
    import("@/Page/Ess/Leave/SubordinateLeaveBalance/SubordinateLeaveBalance"),
  //   ViewSubordinateLeaveBalance:()=>import("@/Page/Ess/Leave/SubordinateLeaveBalance/viewSubordinateLeaveBalance"),
  //   Roster
  RosterRecord: () => import("@/Page/Ess/Roster/RosterRecord/RosterRecord"),
  RosterFormRecord: () =>
    import("@/Page/Ess/Roster/RosterFormRecord/RosterFormRecord"),
  ViewRosterFormRecord: () =>
    import("@/Page/Ess/Roster/RosterFormRecord/ViewRosterFormRecord"),
  EditRosterFormRecord: () =>
    import("@/Page/Ess/Roster/RosterFormRecord/EditRosterFormRecord"),
  //   我的排班
  MyShift: () => import("@/Page/Ess/Roster/MyShift/MyShift"),
  // 报销
  ClaimApplication: () =>
    import("@/Page/Ess/Claim/ClaimApplication/ClaimApplication"),
  ViewClaimApplication: () =>
    import("@/Page/Ess/Claim/ClaimApplication/ViewClaimApplication"),
  newClaimApplication: () =>
    import("@/Page/Ess/Claim/ClaimApplication/newClaimApplication"),
  //   报销结余
  ClaimBalance: () => import("@/Page/Ess/Claim/ClaimBalance/ClaimBalance"),
  // 审批
  ApprovalApplication: () =>
    import("@/Page/Ess/Approval/Approval/ApprovalApplication"),
  ApprovalClaimDetail: () =>
    import("@/Page/Ess/Approval/Approval/ApprovalClaimDetail"),
  ApprovalAttendanceDetail: () =>
    import("@/Page/Ess/Approval/Approval/ApprovalAttendanceDetail"),
  ApprovalRosterDetail: () =>
    import("@/Page/Ess/Approval/Approval/ApprovalRosterDetail"),
  ApprovalLeaveDetail: () =>
    import("@/Page/Ess/Approval/Approval/ApprovalLeaveDetail"),
  ApprovalCustomFormDetail: () =>
    import("@/Page/Ess/Approval/Approval/ApprovalCustomFormDetail"),
  ApprovalAbnormalDetail: () =>
    import("@/Page/Ess/Approval/Approval/ApprovalAbnormalDetail"),
  // 代理审批
  ApprovalApplicationOnBehalf: () =>
    import("@/Page/Ess/Approval/ApprovalOnBehalf/ApprovalApplication"),
  ApprovalClaimDetailOnBehalf: () =>
    import("@/Page/Ess/Approval/ApprovalOnBehalf/ApprovalClaimDetail"),
  ApprovalAttendanceDetailOnBehalf: () =>
    import("@/Page/Ess/Approval/ApprovalOnBehalf/ApprovalAttendanceDetail"),
  ApprovalRosterDetailOnBehalf: () =>
    import("@/Page/Ess/Approval/ApprovalOnBehalf/ApprovalRosterDetail"),
  ApprovalLeaveDetailOnBehalf: () =>
    import("@/Page/Ess/Approval/ApprovalOnBehalf/ApprovalLeaveDetail"),
  ApprovalCustomFormDetailOnBehalf: () =>
    import("@/Page/Ess/Approval/ApprovalOnBehalf/ApprovalCustomFormDetail"),
  ApprovalAbnormalDetailOnBehalf: () =>
    import("@/Page/Ess/Approval/ApprovalOnBehalf/ApprovalAbnormalDetail"),
  // 代理审批接收设置
  ApprovalOnBehalfReceivedApplication: () =>
    import(
      "@/Page/Ess/Approval/ApprovalOnBehalfReceived/ApprovalOnBehalfReceivedApplication"
    ),
  ViewApprovalOnBehalfReceivedApplication: () =>
    import(
      "@/Page/Ess/Approval/ApprovalOnBehalfReceived/ViewApprovalOnBehalfReceivedApplication"
    ),
  // 代理审批设置
  ApprovalOnBehalfSettingApplication: () =>
    import(
      "@/Page/Ess/Approval/ApprovalOnBehalfSetting/ApprovalOnBehalfSettingApplication"
    ),
  newApprovalOnBehalfSetting: () =>
    import(
      "@/Page/Ess/Approval/ApprovalOnBehalfSetting/newApprovalOnBehalfSetting"
    ),
  ViewApprovalOnBehalfSetting: () =>
    import(
      "@/Page/Ess/Approval/ApprovalOnBehalfSetting/ViewApprovalOnBehalfSetting"
    ),
  // 我的申请//代理申请
  MyApplication: () =>
    import("@/Page/Ess/MyApplication/MyApplication/MyApplication"),
  ApplicationOnBehalf: () =>
    import("@/Page/Ess/MyApplication/ApplicationOnBehalf/ApplicationOnBehalf"),
  AbnormalDetail: () =>
    import("@/Page/Ess/MyApplication/MyApplication/AbnormalDetail"),
  AttendanceDetail: () =>
    import("@/Page/Ess/MyApplication/MyApplication/AttendanceDetail"),
  CustomFormDetail: () =>
    import("@/Page/Ess/MyApplication/MyApplication/customFormDetail"),
  ClaimDetail: () =>
    import("@/Page/Ess/MyApplication/MyApplication/ClaimDetail"),
  LeaveDetail: () =>
    import("@/Page/Ess/MyApplication/MyApplication/LeaveDetail"),
  RosterDetail: () =>
    import("@/Page/Ess/MyApplication/MyApplication/RosterDetail"),
  // 自定义申请
  CustomFormRecord: () =>
    import("@/Page/Ess/MyApplication/CustomFormRecord/CustomFormRecord"),
  newCustomFormRecord: () =>
    import("@/Page/Ess/MyApplication/CustomFormRecord/newCustomFormRecord"),
  viewCustomFormRecord: () =>
    import("@/Page/Ess/MyApplication/CustomFormRecord/viewCustomFormRecord"),
  // 我的考勤
  MyAttendance: () => import("@/Page/Ess/Attendance/MyAttendance/MyAttendance"),
  ViewMyAttendance: () =>
    import("@/Page/Ess/Attendance/MyAttendance/ViewMyAttendance"),
  //下属考勤申请
  SubordinateAttendance: () =>
    import("@/Page/Ess/Attendance/SubordinateAttendance/SubordinateAttendance"),
  ViewSubordinateAttendance: () =>
    import(
      "@/Page/Ess/Attendance/SubordinateAttendance/ViewSubordinateAttendance"
    ),
  // 考勤修改申请
  AttendanceRecordModificationApplication: () =>
    import(
      "@/Page/Ess/Attendance/AttendanceRecordModificationApplication/AttendanceRecordModificationApplication"
    ),
  ViewAttendanceRecordModificationApplication: () =>
    import(
      "@/Page/Ess/Attendance/AttendanceRecordModificationApplication/ViewAttendanceRecordModificationApplication"
    ),
  // 异常打卡
  AbnormalClockIn: () =>
    import("@/Page/Ess/Attendance/AbnormalClockIn/AbnormalClockIn"),
  ViewAbnormalClockIn: () =>
    import("@/Page/Ess/Attendance/AbnormalClockIn/ViewAbnormalClockIn"),
  // 打开记录
  PunchRecord: () => import("@/Page/Ess/Attendance/PunchRecord/PunchRecord"),
  // 公告
  Announcement: () => import("@/Page/Ess/Announcement/Announcement"),
  // 文件中心
  DocumentCenter: () => import("@/Page/Ess/DocumentCenter/DocumentCenter"),
  // 工资，税单
  Payslip: () => import("@/Page/Ess/PersonalCenter/Payslip/Payslip"),
  Tax: () => import("@/Page/Ess/PersonalCenter/Tax/Tax"),
  Admin: {
    // 审批
    Approval: () => import("@/Page/EssAdmin/Approval/Approval/Approval"),
  },
};
